import { render, staticRenderFns } from "./CaseItem.vue?vue&type=template&id=37813b3a&scoped=true"
import script from "./CaseItem.vue?vue&type=script&lang=js"
export * from "./CaseItem.vue?vue&type=script&lang=js"
import style0 from "./CaseItem.vue?vue&type=style&index=0&id=37813b3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37813b3a",
  null
  
)

export default component.exports